/* unplugin-vue-components disabled */import { render } from "./eryuanIntro.vue?vue&type=template&id=4f411021&scoped=true"
import script from "./eryuanIntro.vue?vue&type=script&lang=js"
export * from "./eryuanIntro.vue?vue&type=script&lang=js"

import "./eryuanIntro.vue?vue&type=style&index=0&id=4f411021&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f411021"]])

export default __exports__